document.addEventListener("DOMContentLoaded", function () {
  // 获取折叠按钮和标题元素
  const showMoreBtn = document.getElementById("show_more_btn");
  const titleElement = document.querySelector(".m-product-title");

  if (showMoreBtn && titleElement) {
    // 初始隐藏按钮
    showMoreBtn.style.display = "none";

    // 初始状态：对应 is_collapse_title 为 true（已折叠）
    let isCollapsed = true;

    // 检查标题是否超出 2 行
    function checkTitleOverflow() {
      const lineHeight = parseInt(
        getComputedStyle(titleElement).lineHeight,
        10
      );
      const titleHeight = titleElement.scrollHeight;
      const screenWidth = window.innerWidth;
       
      if (titleHeight < 2.5 * lineHeight || screenWidth > 768) {
        showMoreBtn.style.display = "none";
        titleElement.classList.remove("collapse");
      } else {
        showMoreBtn.style.display = "block";
      }
    }

    // 初始检查
    checkTitleOverflow();

    // 绑定点击事件
    showMoreBtn.addEventListener("click", function () {
      // 取反状态
      isCollapsed = !isCollapsed;
      // 切换 collapse 类（控制多行省略样式）
      if (isCollapsed) {
        titleElement.classList.add("collapse");
      } else {
        titleElement.classList.remove("collapse");
      }

      // 旋转箭头图标（可选，根据实际图标结构调整）
      showMoreBtn.style.transform = isCollapsed
        ? "rotate(0deg)"
        : "rotate(180deg)";
    });
  }
});
